export default __webpack_public_path__ + "static/media/pxgroup04.390488b2.png";